import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ClientLogService } from './client-log.service';

const RELOAD_KEY = 'tdt.chunkReloadAt';

/** Catches unhandled client errors and forwards them to the backend log sink. */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private readonly injector: Injector) {}

  handleError(error: any): void {
    try {
      const message = error?.message ?? String(error);
      this.injector.get(ClientLogService).log('error', message, error?.stack);
      if (/Failed to fetch dynamically imported module|Importing a module script failed/.test(message)) {
        this.reloadForNewBuild();
      }
    } catch {
      // Logging must never mask the original error.
    }
    console.error(error);
  }

  /**
   * A tab opened before a deploy still runs the old bundle; its lazy chunks are gone from the
   * server, so menus stop working (and the old session code keeps running). Reload once to pick
   * up the new build. ponytail: at most one reload per minute so a real outage can't loop.
   */
  private reloadForNewBuild(): void {
    let last = 0;
    try { last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0; } catch { /* unavailable */ }
    if (Date.now() - last < 60_000) return;
    try { sessionStorage.setItem(RELOAD_KEY, String(Date.now())); } catch { /* unavailable */ }
    location.reload();
  }
}
